<template>
  <v-form
    @submit="onSubmit"
    :action="this.server + this.$route.fullPath"
    ref="form"
    id="form-contact"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      dense
      outlined
      name="name"
      :rules="nameRules"
      label="Nome"
      required
    ></v-text-field>

    <v-row class="my-0">
      <v-col cols="12" lg="6" class="py-0">
        <v-text-field
          dense
          outlined
          name="tel"
          :rules="telRules"
          label="Telefone"
          required
          v-mask="['(##) ####-####', '(##) #####-####']"
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="6" class="py-0">
        <v-text-field
          dense
          outlined
          name="email"
          :rules="emailRules"
          label="E-mail"
          required
        ></v-text-field>
      </v-col>
    </v-row>

    <v-textarea
      no-resize
      dense
      outlined
      name="text"
      :rules="messageRules"
      label="Mensagem"
      required
    ></v-textarea>

    <v-checkbox
      name="policy_privacy"
      v-model="policy_privacy"
      :rules="[(v) => !!v || 'Você precisa aceitar para continuar.']"
      required
      value="1"
      class="mt-0 policy-privacy"
    >
      <template v-slot:label>
        <div>
          Eu li e concordo com a
          <a class="primary--text" @click="showPrivacy">
            Política de Privacidade.
          </a>
        </div>
      </template>
    </v-checkbox>

    <div class="text-center">
      <v-btn
        color="primary"
        :loading="loadingForm"
        class="white--text py-4 px-12 mt-2 font-weight-bold btn-contact"
        type="submit"
        depressed
        tile
        height="42"
      >
        ENVIAR
      </v-btn>
    </div>

    <v-snackbar :color="color" centered v-model="snackbar" :multi-line="true">
      {{ response }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false" icon>
          <v-icon> fa fa-times </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import { telTest } from "../../utils/telTest";

export default {
  data: () => ({
    response: "",
    color: "success",
    loadingForm: false,
    snackbar: false,
    valid: true,
    nameRules: [(v) => !!v || "Digite seu nome."],
    emailRules: [
      (v) => !!v || "Digite seu e-mail.",
      (v) => /.+@.+\..+/.test(v) || "Digite um e-mail válido.",
    ],
    telRules: [
      (v) => !!v || "Digite seu telefone.",
      (v) => telTest(v) || "Digite um telefone válido",
    ],
    messageRules: [(v) => !!v || "Digite sua mensagem."],
    policy_privacy: false,
  }),
  methods: {
    showPrivacy: () => window.showPrivacyPolicy(),
    onSubmit(event) {
      const form = document.getElementById("form-contact");

      if (this.$refs.form.validate()) {
        this.loadingForm = true;

        const formData = new FormData(form);
        const action = `${this.server}/rest/email/contact-us`;

        fetch(action, {
          method: "POST",
          body: formData,
        })
          .then((r) => {
            if (r.ok) {
              this.$router.push("/fale-conosco/obrigado");
            } else {
              this.response =
                "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
              this.color = "red accent-2";
            }
          })
          .catch(() => {
            this.response =
              "OPS! tivemos um problema no envio das informações, tente novamente mais tarde.";
            this.color = "red accent-2";
          })
          .finally(() => {
            this.snackbar = true;
            this.loadingForm = false;
          });
      }

      event.preventDefault();
    },
  },
  directives: {
    mask,
  },
};
</script>
